import styled from 'styled-components';
import {getSpacing, getToken} from '@tickchak/react-share/app';
import {dFlexCenter} from '../../../../globalVariables/GlobalFlex';
import {STRONG_BLUE} from '../../../../globalVariables/GlobalVariables';

export const row = styled.div<{isEmpty?: boolean}>`
    ${dFlexCenter};
    width: 100%;
    border-bottom: 1px solid ${props => props.isEmpty ? getToken('color.state.warning.main') : getToken('color.border.subtle')};
    min-height: 40px;
    &:last-child {
        border-bottom: none;
    }
`;

export const contentEditable = styled.div`
    flex: 1;
    min-height: 20px;
    outline: none;
    color: ${getToken('color.text.default')};
    position: relative;
    padding: ${getSpacing('spaceSm')} ${getSpacing('spaceMd')};
    direction: ${p => p.theme.direction};

    &[data-is-empty='true'] {
        color: ${getToken('color.state.warning.main')};
        font-weight: bold;
    }

    .variable {
        font-weight: bold;
        color: ${STRONG_BLUE};
    }

    strong {
        font-weight: bold;
    }

    em {
        font-style: italic;
    }
`;
